import { Modal, ModalContent } from '@nextui-org/react';

/**
 * A short question before something is taken away (a food from the plan or from the day): the title says what goes,
 * one line says where from, and the destructive button sits last. The undo toast still follows the removal; this
 * stops the slip before it happens.
 */
export const ConfirmDialog = ({ isOpen, title, text, confirmLabel, cancelLabel, onConfirm, onCancel }) => (
  <Modal
    isOpen={isOpen}
    onOpenChange={(open) => !open && onCancel()}
    placement="center"
    hideCloseButton
    aria-label={title}
    classNames={{ base: 'mt-root mt-dialog', backdrop: 'mt-dialog__backdrop' }}
  >
    <ModalContent>
      {() => (
        <div className="mt-dialog__body">
          <h2 className="mt-dialog__title">{title}</h2>
          {text && <p className="mt-dialog__text">{text}</p>}
          <div className="mt-dialog__actions">
            <button type="button" className="mt-btn mt-btn--quiet" onClick={onCancel}>
              {cancelLabel}
            </button>
            <button type="button" className="mt-btn mt-btn--danger" onClick={onConfirm}>
              {confirmLabel}
            </button>
          </div>
        </div>
      )}
    </ModalContent>
  </Modal>
);
